(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/transfer-analyses.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/transfer-analyses.js');
"use strict";


const {
  ReactButton
} = svs.ui;
const {
  useTransferAnalyses
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const {
  useQueryParam
} = svs.components.lbUtils;
const makePosessiveName = name => {
  if (name.length === 0) {
    return name;
  }
  const lastChar = name[name.length - 1].toLowerCase();
  if (lastChar === 's' || lastChar === 'z' || lastChar === 'x') {
    return name;
  }
  return "".concat(name, "s");
};
const TransferAnalyses = _ref => {
  let {
    drawId,
    setCoupon,
    eventTypeId,
    sportType
  } = _ref;
  const transferAnalyses = useTransferAnalyses(drawId, eventTypeId, sportType);
  const isSmallDevice = Boolean(useQueryParam('openStatistic') !== null);
  return React.createElement("div", {
    className: "transfer-analyses"
  }, transferAnalyses.map(_ref2 => {
    let {
      authorName,
      id,
      signs
    } = _ref2;
    return React.createElement(ReactButton, {
      block: isSmallDevice,
      focus: isSmallDevice,
      inverted: !isSmallDevice,
      key: id,
      onClick: () => {
        setCoupon(signs);
      },
      size: 300
    }, "Anv\xE4nd", ' ', makePosessiveName(authorName), ' ', "rad som grundrad");
  }));
};
setGlobal('svs.component.analyze.TransferAnalyses', TransferAnalyses);

 })(window);